import React from 'react';
import './ViewToggle.scss';

const ViewToggle = ({ activeView, onViewChange }) => {
  return (
    <div className="view-toggle">
      <button
        className={`view-toggle__button ${activeView === 'week' ? 'view-toggle__button--active' : ''}`}
        onClick={() => onViewChange('week')}
      >
        Week
      </button>
      <button
        className={`view-toggle__button ${activeView === 'month' ? 'view-toggle__button--active' : ''}`}
        onClick={() => onViewChange('month')}
      >
        Month
      </button>
    </div>
  );
};

export default ViewToggle;
